import { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

function MenusPerDayChart(props) {
    const { menus } = props;
    const [menu, setMenu] = useState([]);

    useEffect(() => {
        if (menus && menus.length > 0) {
            const menuPerDay = {};
            menus.forEach(menu => {
                const today = new Date(menu.createdAt).toLocaleDateString();
                if (menuPerDay[today]) {
                    menuPerDay[today]++;
                } else {
                    menuPerDay[today] = 1;
                }
            });

            const data = Object.entries(menuPerDay).map(([date, count]) => ({ date, count }));
            setMenu(data);
        }
    }, [menus]);

    const option = {
        title: {
            text: "Menus par jour",
            textStyle: {
                color: 'black'
            },
            left: '50%',
            top: '5%',
            textAlign: 'center'
        },
        tooltip: {
            trigger: 'item'
        },
        xAxis: {
            type: 'category',
            data: menu.map(item => item.date)
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                name: 'Menu ajouté',
                data: menu.map(item => item.count),
                type: 'bar',
                smooth: true,
                lineStyle: {
                    color: '#ffcc44'
                },
                itemStyle: {
                    color: '#080814'
                }
            }
        ]
    };

    return (
        <div className="card" style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}>
            <ReactECharts
                style={{ height: "300px", width: "100%" }}
                option={option}
            />
        </div>
    );
}

export default MenusPerDayChart;
